import { useEffect, useState } from "react";
import makeAnimated from "react-select/animated";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import CodeField from "../Reusable/CodeField";
import SwitchButton from "../Reusable/SwitchButton";
import { Group, Panel, Separator } from "react-resizable-panels";
import TabPanel from "../Reusable/Tab";
import MobilePreview from "../Reusable/MobilePreview/MobilePreview";

const animatedComponents = makeAnimated();

const ReceiverStatusForm = ({
  register,
  errors,
  setValue,
  watch,
  control,
}: any) => {
  const isSenderActive = watch("is_sender_active");
  const [defaultValue, setDefaultValue] = useState();
  const emailHtml = watch("sender_email_content");
  const smsContent = watch("sender_sms_content");

  const onChange = (value: any) => {
    setValue("next_status", value);
    setDefaultValue(value);
  };

  useEffect(() => {
    if (!defaultValue) {
      setDefaultValue(watch("next_status"));
    }
  }, [watch("next_status")]);

  return (
    <div className={tw`px-2`}>
      <TabPanel
        tabTitle={["SMS Content", "Email Content"]}
        tabPanels={[
          <>
            <div className={tw`grid grid-cols-3 `}>
              <div className={tw`my-1 col-span-2`}>
                <label>Sms Content</label>
                <textarea
                  rows={6}
                  maxLength={120}
                  {...register("sender_sms_content")}
                  className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                />
                {errors?.sender_sms_content && (
                  <p className={tw`text-red-500 text-xs my-1`}>
                    {errors?.sender_sms_content?.message}
                  </p>
                )}
              </div>
              <div
                className={tw`hidden lg:flex h-full w-full items-center justify-center`}
              >
                <MobilePreview
                  imageUrl="https://dev-dib-pos-frontend-service-v3.s3.ap-south-1.amazonaws.com/digital-marketing-frontend-service/dist/30f7156109f80ad3a4d3.png"
                  description="SMS Preview"
                  message={smsContent}
                />
              </div>
            </div>
          </>,

          <div className={tw`grid grid-cols-3 `}>
            <div className={tw`my-1 col-span-2`}>
              <CodeField
                control={control}
                name="sender_email_content"
                label="Email Content"
              />
            </div>

            <div
              className={tw`hidden lg:flex h-full w-full items-start justify-center`}
            >
              <MobilePreview
                imageUrl="https://dev-dib-pos-frontend-service-v3.s3.ap-south-1.amazonaws.com/digital-marketing-frontend-service/dist/30f7156109f80ad3a4d3.png"
                description="Email Preview"
                message={emailHtml}
              />
            </div>
          </div>,
        ]}
      />
      <div className={tw`flex justify-end items-center`}>
        <label className={tw`text-center`}>Active :&nbsp;&nbsp;</label>
        <SwitchButton
          value={!!isSenderActive}
          disabled={false}
          onChange={(val) => {
            setValue("is_sender_active", val, { shouldDirty: true });
          }}
        />
      </div>

      {/* <RichTextEditor
        name="email_content"
        control={control}
        setValue={setValue}
        errors={errors.email_content}
        label="Email Content"
      /> */}
    </div>
  );
};

export default ReceiverStatusForm;
